import Swiper, {EffectFade, Navigation, Thumbs, Autoplay} from 'swiper';
import {Labels} from '../../typings';

Swiper.use([Navigation, Thumbs, EffectFade, Autoplay]);

export function initSlider() {
  let swiper;
  const breakpoint = window.matchMedia('(min-width:1441px)');

  function breakpointChecker() {
    if (breakpoint.matches) {
      if (swiper !== undefined) {
        swiper.destroy(true, true);
      }
      return;
    } else {
      if (document.querySelectorAll('.js-teaserSlider').length) {
        swiper = new Swiper('.js-teaserSlider', {
          initialSlide: 1,
          centeredSlides: true,
          spaceBetween: 30,
          slidesPerView: 1.4,
          breakpoints: {
            460: {
              slidesPerView: 1.4,
            },
            786: {
              slidesPerView: 2.5,
            },
            1441: {
              slidesPerView: 4,
            },
          },
        });
      }
    }
  }

  breakpointChecker();
  breakpoint.addEventListener('change', breakpointChecker);
}

export function initSwiperGallery() {
  const thumbs = document.querySelectorAll('.js-swiper-gallery-thumbs[data-uid]');
  thumbs.forEach((thumb) => {
    const dataUid = thumb.getAttribute('data-uid');
    const swiperGalleryThumbs = new Swiper(`.js-swiper-gallery-thumbs[data-uid="${dataUid}"]`, {
      spaceBetween: 50,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    const swiperGallery = new Swiper(`.js-swiper-gallery[data-uid="${dataUid}"]`, {
      effect: 'fade',
      thumbs: {
        swiper: swiperGalleryThumbs,
      },
    });

    swiperGalleryThumbs.on('activeIndexChange', function (e) {
      swiperGallery.slideToLoop(e.realIndex);
    });
  });
}

export function initSwiperHeroslider() {
  const slideCount = (document.querySelector('.js-swiper-heroslider')?.querySelectorAll('.swiper-wrapper > .swiper-slide').length) || 0;

  const swiperHeroslider: Swiper = new Swiper('.js-swiper-heroslider', {
    loop: slideCount > 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  const pauseButton: HTMLElement|null = document.querySelector('.js-heroslider-pause');
  if (!pauseButton) {
    return;
  }

  const labels: Labels = {
    'pauseSlideshow': pauseButton.dataset.arialabelplaying || 'Pause slideshow',
    'playSlideshow': pauseButton.dataset.arialabelpausing || 'Play slideshow',
  };

  if (slideCount <= 1) {
    pauseButton.style.display = 'none';
  }

  const setState = (playing: boolean) => {
    pauseButton.dataset.state = playing ? 'playing' : 'paused';
    pauseButton.setAttribute('aria-pressed', playing ? 'false' : 'true');
    pauseButton.setAttribute('aria-label', playing ? labels.pauseSlideshow : labels.playSlideshow);
  };

  pauseButton.addEventListener('click', () => {
    if (swiperHeroslider.autoplay.running) {
      swiperHeroslider.autoplay.stop();
      setState(false);
    } else {
      swiperHeroslider.autoplay.start();
      setState(true);
    }
  });

  swiperHeroslider.on('autoplayStart', () => setState(true));
  swiperHeroslider.on('autoplayStop', () => setState(false));
}

export function initSwiperTimeline() {
  const timelineElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-swiper-timeline');

  timelineElements.forEach((timelineElement) => {
    const timelineThumbsElement = timelineElement.querySelector('.js-swiper-timeline-thumbs') as HTMLElement | null;
    const timelineButtonsElement = timelineElement.querySelector('.timeline__wrapperPhases') as HTMLElement | null;
    const timelinePaginationElement = timelineElement.querySelector('.swiper-pagination') as HTMLElement | null;
    const timelinePrevButtonElement = timelineElement.querySelector('.swiper-button-prev') as HTMLElement | null;
    const timelineNextButtonElement = timelineElement.querySelector('.swiper-button-next') as HTMLElement | null;

    if (!timelineThumbsElement || !timelineButtonsElement) {
      return;
    }

    const swiperDetails = new Swiper(timelineThumbsElement, {
      spaceBetween: 10,
      slidesPerView: 1,
      freeMode: true,
      allowTouchMove: false,
      watchSlidesProgress: true,
      a11y: {
        enabled: true,
      },
      pagination: {
        el: timelinePaginationElement,
        clickable: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
          allowTouchMove: true,
        },
        1441: {
          slidesPerView: 5,
          allowTouchMove: true,
        },
      },
    });

    const swiperTimeline = new Swiper(timelineElement, {
      spaceBetween: 10,
      autoHeight: true,
      navigation: {
        nextEl: timelineNextButtonElement,
        prevEl: timelinePrevButtonElement,
      },
      thumbs: {
        swiper: swiperDetails,
      },
      breakpoints: {
        769: {
          autoHeight: false,
        },
        1441: {
          autoHeight: false,
        },
      },
    });

    timelineButtonsElement.querySelectorAll('.swiper-slide').forEach((element, index) => {
      element.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key !== 'Enter') {
          return;
        }

        e.preventDefault();
        swiperTimeline.slideTo(index);
      });
    });
  });
}

export function initPageTeaserSlider() {
  const pageTeaserElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-pageTeaserSlider');
  const pageTeaserSliderElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-pageTeaserSliderThumbs');

  if (pageTeaserElements.length && pageTeaserSliderElements.length) {
    pageTeaserSliderElements.forEach((teaserSliderElement) => {
      const sliderId = teaserSliderElement.dataset.sliderId;

      if (!sliderId) {
        return;
      }

      const projectSliderThumbs = new Swiper(teaserSliderElement, {
        spaceBetween: 0,
        slidesPerView: 1,
        freeMode: true,
        loop: false,
        watchSlidesProgress: true,
        breakpoints: {
          1440: {
            slidesPerView: 5,
            loop: false,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

      let sliderElement: HTMLElement | null = null;
      pageTeaserElements.forEach((teaserElement) => {
        if (teaserElement.dataset.sliderId === sliderId) {
          sliderElement = teaserElement;
        }
      });

      if (!sliderElement) {
        return;
      }

      const projectSlider = new Swiper(sliderElement, {
        effect: 'fade',
        thumbs: {
          swiper: projectSliderThumbs,
        },
      });

      teaserSliderElement.querySelectorAll('.js-pageThumb').forEach((projectThumb: HTMLElement) => {
        projectThumb.addEventListener('focus', () => {
          const index = projectThumb.dataset.index;
          if (index) {
            projectSlider?.slideTo(parseInt(index, 10));
          }
        });
      });

      // update projectSlider on change of active statement of thumb slider
      projectSliderThumbs.on('activeIndexChange', function (e) {
        projectSlider.slideToLoop(e.realIndex);
      });
    });
  }


}
